<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div class="text-ontick-carbon-900 relative overflow-hidden dark:text-gray-300">
    <div class="relative">
      <div class="lg:mx-auto lg:grid lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-2 lg:gap-24 lg:px-8">
        <div class="mx-auto max-w-xl px-4 sm:px-6 lg:mx-0 lg:max-w-none lg:py-16 lg:px-0">
          <div>
            <div
              class="bg-ontick-graphite-500 flex h-12 w-12 items-center justify-center rounded-lg p-2 dark:bg-transparent dark:p-0"
              v-if="partnerInfo && partnerInfo.extension_logo"
            >
              <img :src="partnerInfo.extension_logo" :alt="`Logo de ${partnerInfo.extension_name}`" class="h-full" />
            </div>
            <div class="mt-6">
              <h2 class="text-3xl font-extrabold tracking-tight">
                {{ data.title }}
              </h2>
              <template v-if="typeof data.text === 'string'">
                <p class="mt-4 text-lg text-gray-500 dark:text-gray-400">
                  {{ data.text }}
                </p>
              </template>
              <template v-else>
                <p
                  class="mt-4 text-lg text-gray-500 dark:text-gray-400"
                  v-for="(paragraph, index) in data.text"
                  :key="index"
                >
                  {{ paragraph }}
                </p>
              </template>
              <!-- <div class="mt-6">
                <a
                  href="#"
                  class="inline-flex rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700"
                >
                  Get started
                </a>
              </div> -->
            </div>
          </div>
          <div class="mt-8 border-t border-gray-200 pt-6" v-if="data.testimonial">
            <blockquote>
              <div class="space-y-4 text-sm">
                <template v-if="Array.isArray(data.testimonial.text)">
                  <p
                    class="text-gray-500 dark:text-gray-400"
                    v-for="(paragraph, index) in data.testimonial.text"
                    :key="index"
                  >
                    <span v-if="index === 0">&ldquo;</span>
                    <span>{{ paragraph }}</span>
                    <span v-if="index === data.testimonial.text.length - 1">&rdquo;</span>
                  </p>
                </template>
                <p class="text-gray-500 dark:text-gray-400" v-else>
                  <span>&ldquo;</span>
                  <span>{{ data.testimonial.text }}</span>
                  <span>&rdquo;</span>
                </p>
              </div>
              <footer class="mt-3" v-if="data.testimonial.author">
                <div class="flex items-center space-x-3">
                  <div class="flex-shrink-0" v-if="data.testimonial.author && data.testimonial.author.picture">
                    <img class="h-6 w-6 rounded-full" :src="data.testimonial.author.picture" alt="" />
                  </div>
                  <div class="text-base font-medium text-gray-500">
                    {{ data.testimonial.author.name }}
                  </div>
                </div>
              </footer>
            </blockquote>
          </div>
        </div>
        <div class="mt-12 sm:mt-16 lg:mt-0">
          <div class="-mr-48 pl-4 sm:pl-6 md:-mr-16 lg:relative lg:m-0 lg:h-full lg:px-0">
            <img
              class="w-full drop-shadow-lg filter lg:absolute lg:left-0 lg:h-full lg:w-auto lg:max-w-none"
              :src="data.img.url"
              :alt="data.img.alt"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
    },
    partnerInfo: {
      type: Object,
    },
  },
};
</script>
